<script lang="ts" setup>
definePageMeta({
  layout: 'auth',
  name: 'login',
})

const route = useRoute()
const { t } = useLocale()
const { setEmail, setPhoneNumber, setToken } = useLoginState()
const returnUrl = useReturnUrl()

const startEmail = computed(() => route.query?.email)

const { submitForm, handleSubmit, handleInvalidSubmit, processing, validationSchema, values, formRef } = useFormCallback({
  successMessage: false,
  values: {
    email: startEmail.value,
  },
  validationSchema(z) {
    return z.object({
      email: z.email(),
    })
  },
  async callback({ values }) {
    const response = await $ssoFetch('login', {
      method: 'POST',
      body: {
        ...values,
        returnUrl: route.query.returnUrl || null,
      },
    })
    setEmail(values.email)
    setPhoneNumber(response.data.phoneNumber)
    setToken(response.data.token)
    await navigateTo({
      name: 'login.confirm',
      query: {
        returnUrl: returnUrl.value,
      },
    })
  },
})

if (startEmail.value) {
  await submitForm()
}
</script>

<template>
  <Form
    ref="formRef"
    :validation-schema
    :values
    :processing
    @submit="handleSubmit"
    @invalid-submit="handleInvalidSubmit"
  >
    <h3 class="title-3xl mb-6 text-center">
      {{ t('login.continueToTicketer.heading') }}
    </h3>
    <div class="space-y-4">
      <BaseFormInput name="email" placeholder="Email" inputmode="email" />
      <BaseFormButton type="submit" class="w-full">
        {{ t('continue.btn') }}
      </BaseFormButton>
    </div>
  </Form>
</template>
